import React, { Component } from "react";

import "./Video.scss";

class Video extends Component {
  render() {
    const { video } = this.props;

    return (
      <div className="video">
        <div class='embed-container'><iframe id="player" src={video + "?rel=0&enablejsapi=1"} frameborder='0' width="800" height="300" allow="autoplay; fullscreen" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe></div>
      </div>
    );
  }
}

export default Video;

/* var playButton = document.getElementById("play_button");
// Event listener for the play/pause button
playButton.addEventListener("click", function() {
  if (video.paused == true) {
    // Play the video
    video.play();

    // Update the button text to 'Pause'
    playButton.innerHTML = "Pause";
  } else {
    // Pause the video
    video.pause();

    // Update the button text to 'Play'
    playButton.innerHTML = "Play";
  }
}); */


